var searchClientsByRmWithOwnClientMapper = function (data) {
    var result = [];
    if (data && data.ranked_employees.length > 0) {
        result = data.ranked_employees.map(function (item) {
            return {
                clientName: item.acname,
                userName: item.user_name,
                accountCode: item.priority_ac_code,
                pan: item.pan,
                mobileNo: item.mobileno,
                email: item.email,
                uniqueCode: item.ucccode,
                isVerified: true,
                dpFlag: item.dp_flag,
                accType: item.actype,
                ucccode: item.ucccode,
                clientTier: item.clienttier,
                accessMsg: item.accessMsg,
                accessStatus: item.accessStatus,
                direct_plan_enabled_flg: item.direct_plan_enabled_flg,
                ispansearch: item.ispansearch,
            };
        });
    }
    return result;
};
export default searchClientsByRmWithOwnClientMapper;
